import { Component, inject } from '@angular/core';
import { ConfigurationHandlerService } from '../core/configuration-handler.service';
import { SEOService } from '../core/seo.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
import { BrandComponent, HtmlSanitizePipe } from '@exl-ng/mulo-common';
import { CenteredBlockLayoutComponent } from '@exl-ng/mulo-views';

@Component({
    selector: 'esp-tombstone-page',
    templateUrl: './tombstone-page.component.html',
    styleUrls: ['./tombstone-page.component.scss'],
    imports: [
        CenteredBlockLayoutComponent,
        BrandComponent,
        NgOptimizedImage,
        TranslateModule,
        HtmlSanitizePipe,
    ],
})
export class TombstonePageComponent {
    constructor() {
        const configSvc = inject(ConfigurationHandlerService);
        const seoSvc = inject(SEOService);
        const xl8 = inject(TranslateService);

        xl8.get('research.search.document.title', {
            value: configSvc.mainInstitutionName(),
        }).subscribe((res) => seoSvc.updateTitle(res));
    }
}
